export enum ActionConstants {
	CHANGE_TRADE_MODE = 'change_trade_mode',
	SET_TRADE_MODE = 'set_trade_mode',
}
